    <div class="backModal">
      <div class="close closeModal">
          <a title="cerrar" (click)="close()"><span class="cross"></span><span class="sr-only">cerrar</span></a>
        </div>
    <div class="busquedaClientes">
      <div class="tituloSearch">
        {{'BUSCA_Y_ELIGE_CLIENTE' | translate }}
      </div>
      <div class="inpuSearch" [formGroup]="clientForm">
        <input type="text" id="search_field" #clientInput formControlName="searchField" category="ALFANUMERICO" [ngClass]="{'active-form' : isSelected(clientInput)}" (focus)="focusValue($event)" autofocus>
        <div class="close" *ngIf="clientForm.controls['searchField'].value">
          <a title="cerrar" (click)="deleteValue()"><span class="cross"></span><span class="sr-only">cerrar</span></a>
        </div>
      </div>
      <div class="listaPredicc">
  
        <div class="Rtable" *ngIf="clientes">
          <div class="Rtable-row Rtable-row--head">
            <div class="Rtable-cell codigo-cell column-heading">{{ 'CLIENTE_CODIGO' | translate}} </div>
            <div class="Rtable-cell cliente-cell column-heading"> {{ 'CLIENTE_NOMBRE' | translate}}</div>
            <div class="Rtable-cell legal-cell column-heading"> {{ 'CLIENTE_DENOMINACION_LEGAL' | translate}}</div>
            <div class="Rtable-cell email-cell column-heading">{{ 'CLIENTE_EMAIL' | translate}}</div>
            <div class="Rtable-cell telefono-cell column-heading">{{ 'CLIENTE_TELEFONO' | translate}}</div>
            <div class="Rtable-cell num-cell column-heading">{{ 'CLIENTE_DNI_CIF' | translate}}</div>
          </div>
            <div class="Rtable-row" (click)="seleccionarCliente(cliente)" *ngFor="let cliente of pagedItems">
              <div class="Rtable-cell codigo-cell">
                <div class="Rtable-cell--content codigo-content">{{cliente.Codigo}}</div>
              </div>
              <div class="Rtable-cell cliente-cell">
                <div class="Rtable-cell--content cliente-content">{{cliente.NombreCliente | slice:0:30}}</div>
              </div>
              <div class="Rtable-cell legal-cell">
                <div class="Rtable-cell--content legal-content">{{cliente.NombreComercial}}</div>
              </div>
              <div class="Rtable-cell email-cell">
                <div class="Rtable-cell--content email-content">{{cliente.EMail}}</div>
              </div>
              <div class="Rtable-cell telefono-cell">
                <div class="Rtable-cell--content telefono-content">{{cliente.Telefono}}</div>
              </div>
              <div class="Rtable-cell num-cell">
                <div class="Rtable-cell--content num-content">{{cliente.CIFoDNI}}</div>
              </div>
            </div>
        </div>
  
        <ul class="pagination" *ngIf="pager.pages">
            <li>
              <a (click)="setPage(pager.currentPage - 1)" title="Previo">
                <img class="svg" src="assets/img/active-arrow.svg" alt="icono prev">
              </a>
            </li>
            <li *ngFor="let page of pager.pages">
                <a (click)="setPage(page)" [ngClass]="{'active':pager.currentPage === page}">{{page}}</a>
            </li>            
            <li>
              <a (click)="setPage(pager.currentPage + 1)" title="Próximo">
                <img class="svg" src="assets/img/active-arrow.svg" alt="icono next">
              </a>
            </li>
          </ul>
  
      </div>
  
    </div>
    <div class="keyboardWrap">
      <ticketing-keyboard></ticketing-keyboard>
      <ticketing-numpad></ticketing-numpad>
    </div>
  </div>
 
